import {useState} from 'react'
import {useCountFaultsQuery} from "./hooks/useCountFaultsQuery.js"
import moment from "moment"
import Textfield from "../../common/components/Textfiled.jsx"
import Pagination from "../../common/components/Pagination.jsx"
import CardNumber from "../../common/components/CardNumber.jsx"
import {Table} from "react-bootstrap"

function CountFaults(){
  const [filters, setFilters] = useState({
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  })
  const {countFaults, totalPages, currentPage, onChangePage, total} = useCountFaultsQuery(filters)

  const handleChangeFilters = ({name, value}) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    })) 
  }
 
    return(
      <main className="container mt-5">
      <header className="my-1 text-center">
        <h1 className="fs-1">Cantidad de fallas</h1>
      </header>
        
      <section className="d-flex flex-column">
        <div className="d-flex justify-content-center gap-3">
          <Textfield
            label="Fecha de inicio"
            type="date"
            name="startDate"
            value={filters.startDate}
            onChange={handleChangeFilters}
          />
          <Textfield
            label="Fecha de fin"
            type="date"
            name="endDate"
            value={filters.endDate}
            onChange={handleChangeFilters}
          /> 
        </div>

        <CardNumber label="Total de encuestas con fallas" number={total} />
        <div className="mt-4">
      <Table striped bordered hover responsive>
        <thead className="table-dark">
          <tr>
            <th>#</th>
            <th>Consecutivo Encuesta</th>
            <th>Cantidad de Fallas</th>
          </tr>
        </thead>
        <tbody>
          {countFaults.length === 0 ? (
            <tr>
              <td colSpan={3} className="text-center py-3">
                No hay datos disponibles
              </td>
            </tr>
          ) : (
            countFaults.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.surveyId ?? 'No disponible'}</td>
                <td>{item.faultCount}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

          <Pagination page={currentPage} totalPages={totalPages} onChangePage={onChangePage} />
    </div>
      </section>
    </main>
    )
  }

export default CountFaults
